import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get('/courses').then(r => setCourses(r.data)); }, []);
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Mi aprendizaje" subtitle="Cursos y niveles disponibles" testId="courses-header" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {courses.map(c => (
          <Link key={c.id} to={`/student/courses/${c.id}`} data-testid={`course-card-${c.id}`}
            className="rounded-2xl bg-white border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all">
            <div className="h-40 bg-slate-100" style={{backgroundImage:`url(${c.cover_url})`, backgroundSize:'cover', backgroundPosition:'center'}}/>
            <div className="p-5">
              <div className="font-display font-bold text-lg">{c.title}</div>
              <div className="text-sm text-slate-500 mt-1 line-clamp-2">{c.description}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
